/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationResolutionBase {
    getFixupPrototypeFunction() { return RecommendationResolutionBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationResolutionBase>): RecommendationResolutionBase {
        let obj = Object.assign(new RecommendationResolutionBase(), model);
        RecommendationResolutionBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationResolutionBase>): RecommendationResolutionBase {
        if (!model) return null;
        return RecommendationResolutionBase.newInstance(<RecommendationResolutionBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationResolutionBase) {
        if (!obj) return;

        models.RecommendationResolutionBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationResolutionBase): boolean {
        Object.setPrototypeOf(obj, RecommendationResolutionBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.key_value_mapper) {
            for (let val of this.key_value_mapper) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name for the validator action
     */
    validator_name: string;

    /**
     * Indicates the source for checking the resolution of resource recommendation
     */
    source: models.ResourceRecommendationResolutionSource;

    /**
     * Indicates the action for the resource recommendation
     */
    action_type: models.ResourceRecommendationSupportedAction;

    /**
     * Indicates the list of conditions supported  for the resource recommendation validation check
     */
    condition_checker: models.RecommendationSupportedValidators;

    /**
     * List of tag key/value pairs
     */
    key_value_mapper: Array<models.KeyValuePair>;

    /**
     * key to indicate after validation should the record consider for closure
     */
    eligible_for_closure: boolean = false;

}
